var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "nts-logo",
  "use": "nts-logo-usage",
  "viewBox": "-37 -37 100 100",
  "content": "<symbol viewBox=\"-37 -37 100 100\" id=\"nts-logo\">\r\n<path fill=\"#00000\" d=\"M50.43-10.483l-1.827,7.997h-5.735l1.748-7.648c0.554-2.433,0.361-4.259-2.335-4.259\r\n\ts-3.72,1.826-4.276,4.259L36.5-3.53c-0.451,2.002-0.564,3.998,0.015,5.65l5.559,15.649c0.809,2.169,0.975,4.866,0.339,7.646\r\n\tl-2.261,9.909c-1.351,5.912-5.577,9.211-11.315,9.211c-6.345,0-8.732-2.87-7.285-9.211l1.963-8.608h5.738l-1.888,8.263\r\n\tc-0.673,2.952,0.064,4.69,2.584,4.69c2.347,0,3.874-1.738,4.544-4.69l2.004-8.781c0.516-1.982,0.418-4.072-0.282-5.999L31.13,5.509\r\n\tc-0.944-2.696-1.34-4.776-0.606-7.996l1.727-7.563c1.406-6.169,5.318-9.212,11.144-9.212c6.431,0,8.346,3.042,7.036,8.781V-10.483z\r\n\t M6.096,44.02l13.21-57.89h-6.431l1.11-4.863h18.601l-1.113,4.863h-6.435L11.831,44.02H6.096z M-11.199,44.02l5.516-55.802h-0.175\r\n\tL-18.589,44.02h-5.041l14.317-62.756h8.341l-5.21,53.715h0.173L6.246-18.737h5.045L-3.034,44.016h-8.165V44.02z M-37.017,62.983h100\r\n\tv-100h-100V62.983z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/nts-logo.icon
// module id = 283
// module chunks = 35783957827783